import React, { useContext, createContext, useMemo, useState } from 'react';

const DataProviderContext = createContext();

export const useDataProvider = () => {
  const context = useContext(DataProviderContext);
  return context;
};

export const DataProvider = ({ children }) => {
  const [practiceArea, setPracticeArea] = useState([]);
  const [venueOptions, setVenueOptions] = useState([]);
  const [conferenceRoomOptions, setConferenceRoomOptions] = useState([]);
  const [tagList, setTagList] = useState(null);
  const [caseStageList, setCaseStageList] = useState([]);
  const [leadStages, setLeadStages] = useState([]);
  const [caseMatterList, setCaseMatterList] = useState([]);
  const [eventLocations, setEventLocations] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const [timerList, setTimerList] = useState([]);

  const clearAllData = () => {
    setPracticeArea([]);
    setVenueOptions([]);
    setConferenceRoomOptions([]);
    setTagList(null);
    setCaseStageList([]);
    setLeadStages([]);
    setCaseMatterList([]);
    setEventLocations([]);
    setTypeList([]);
    setActivityTypes([]);
    setTimerList([]);
  };

  const values = useMemo(
    () => ({
      practiceArea,
      setPracticeArea,
      venueOptions,
      setVenueOptions,
      conferenceRoomOptions,
      setConferenceRoomOptions,
      tagList,
      setTagList,
      caseStageList,
      setCaseStageList,
      leadStages,
      setLeadStages,
      caseMatterList,
      setCaseMatterList,
      eventLocations,
      setEventLocations,
      typeList,
      setTypeList,
      clearAllData,
      activityTypes,
      setActivityTypes,
      timerList,
      setTimerList,
    }),
    [
      practiceArea,
      venueOptions,
      conferenceRoomOptions,
      tagList,
      caseStageList,
      leadStages,
      caseMatterList,
      eventLocations,
      typeList,
      timerList,
      activityTypes,
    ]
  );

  return <DataProviderContext.Provider value={values}>{children}</DataProviderContext.Provider>;
};
